
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class UploadsService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${UploadsService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/uploads';

    public uploadImage(file: any): Observable<SuccessResponse<string> | ErrorResponse> {
        const model = new FormData();
        model.append('file', file);
        return this.http
            .post<SuccessResponse<string>>(UploadsService.URL + '/image', model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
